const decodeHtml = (htmlString) => {

	const elem = document.createElement('textarea');
	elem.innerHTML = htmlString;
	return elem.value;

};

export default decodeHtml;
